module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "name": "fade"
    }
  }, [(_vm.active) ? _c('div', {
    ref: "tooltip",
    class: {
      tooptip: true
    },
    style: ({
      top: _vm.top + 'px',
      left: _vm.left + _vm.maxWidth + 'px',
      maxWidth: _vm.maxWidth + 'px'
    }),
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" \n\t \t   " + _vm._s(_vm.message) + " \n\t     "), _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-575b4007!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Misc/Tooltip.vue
// module id = 159
// module chunks = 0